<div class="relative flex h-full w-full flex-col" [style.minHeight]="adjustedMinHeight()" [style.maxHeight]="maxHeight()">
  <div #zoomElement class="relative flex h-full max-h-full min-h-full w-full flex-1 select-none overflow-hidden object-contain" *transloco="let t">
    <div
      class="flex-1 origin-top-left touch-manipulation select-none snap-start"
      [ngClass]="{ 'cursor-move': isScaled, 'cursor-zoom-in': !isScaled }"
      [style.transform]="transform()">
      <ng-content></ng-content>
    </div>
  </div>

  <p-button
    severity="contrast"
    variant="outlined"
    iconPos="left"
    icon="pi pi-undo"
    iconPos="right"
    size="small"
    class="absolute inset-x-0 bottom-12 grid place-items-center [&_button]:bg-white"
    [label]="'global.reset' | transloco"
    [ngClass]="{ hidden: !isScaled }"
    (onClick)="reset()" />

  <div
    *ngIf="showHint"
    class="absolute inset-x-0 bottom-0 flex justify-center gap-2 border-stone-800 bg-violet-50 px-3 py-2 pr-9 text-xs leading-5 max-lg:hidden">
    @if (isScaled) {
      <span>
        <i class="pi pi-search-plus ml-1 !text-xs"></i>
        {{ 'zoom.title.in' | transloco }}
      </span>

      <span>
        <i class="pi pi-arrows-alt ml-1 !text-xs"></i>
        {{ 'zoom.title.move' | transloco }}
      </span>

      <span>
        <i class="pi pi-undo ml-1 !text-xs"></i>
        {{ 'zoom.title.out' | transloco }}
      </span>
    } @else {
      <i class="pi pi-search-plus ml-1 !text-xs"></i>
      {{ 'zoom.title.in' | transloco }}
    }
  </div>
</div>
